<template>
	<transition name="slide-down">
        <div class="error-text" v-if="errors && errors.length > 0">
            <div v-for="error in errors">{{ error }}</div>
        </div>
    </transition>
</template>

<script>
	export default {
		props: ['errors']
	}
</script>